import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import style from './SuiteSidebar.module.css'

const SuiteSidebar = ({ isOpen, onClose, onLogout, onNavigate, onOpenLauncher, launcherOpen, launcherRef }) => {
  const location = useLocation()
  const handleLogout = event => {
    onClose()
    onLogout(event)
  }
  const handleNavigation = (event, destination) => {
    if (destination !== location.pathname && onNavigate) {
      event.preventDefault()
      onNavigate(destination)
    }

    onClose()
  }

  return (
    <>
      <button
        aria-hidden={!isOpen}
        aria-label="Cerrar menú de navegación"
        className={`${style.backdrop} ${isOpen ? style.backdropVisible : ''}`}
        disabled={!isOpen}
        onClick={onClose}
        tabIndex={isOpen ? 0 : -1}
        type="button"
      />
      <aside aria-label="Navegación principal" className={`${style.sidebar} ${isOpen ? style.open : ''}`} id="suite-sidebar">
        <nav className={style.navigation}>
          <NavLink aria-label="Promociones" activeClassName={style.active} exact onClick={event => handleNavigation(event, '/')} title="Promociones" to="/">
            <svg aria-hidden="true" className={style.icon} viewBox="0 0 24 24">
              <path d="M4 5.5A1.5 1.5 0 0 1 5.5 4h13A1.5 1.5 0 0 1 20 5.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18.5zM8 8h8M8 12h8M8 16h5" />
            </svg>
            <span className={style.label}>Promociones</span>
          </NavLink>
          <NavLink aria-label="Crear promoción" activeClassName={style.active} onClick={event => handleNavigation(event, '/crear-promocion')} title="Crear promoción" to="/crear-promocion">
            <svg aria-hidden="true" className={style.icon} viewBox="0 0 24 24">
              <path d="M12 5v14M5 12h14" />
            </svg>
            <span className={style.label}>Crear promoción</span>
          </NavLink>
        </nav>
        <button aria-label="Mis aplicaciones" aria-haspopup="dialog" aria-expanded={launcherOpen}
          className={style.logout} disabled={!onOpenLauncher} onClick={onOpenLauncher}
          ref={launcherRef} title="Mis aplicaciones" type="button">
          <svg aria-hidden="true" className={style.icon} viewBox="0 0 24 24">
            <path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z" />
          </svg>
          <span className={style.label}>Mis aplicaciones</span>
        </button>
        <button aria-label="Cerrar sesión" className={style.logout} disabled={!onLogout} onClick={handleLogout} title="Cerrar sesión" type="button">
          <svg aria-hidden="true" className={style.icon} viewBox="0 0 24 24">
            <path d="M10 5H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4M14 8l4 4-4 4M18 12H9" />
          </svg>
          <span className={style.label}>Cerrar sesión</span>
        </button>
      </aside>
    </>
  )
}

export default SuiteSidebar
